import { Box } from '@mui/material';

import logoDark from '../../assets/images/quibbleaiLogoDark.svg';
import AuthPageRightSection from './SignupJourney.tsx/AuthPageRightSection';

const CommonAuthLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          flex: '1 1 50%',
          display: 'flex',
          flexDirection: 'column',
          p: { xs: 2, sm: 2, md: 2, lg: 2 },
          bgcolor: 'white',
          overflow: 'auto',
          alignItems: 'flex-start',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            width: '100%',
          }}
        >
          <img
            src={logoDark}
            alt="Quibble AI"
            loading="eager"
            style={{
              width: 'clamp(120px, 25vw, 146px)',
              height: 'auto',
            }}
          />
        </Box>
        {/* Left Section - Form */}
        {children}
      </Box>

      {/* Right Section */}
      <Box
        sx={{
          flex: '1 1 50%',
          display: { xs: 'none', md: 'block' },
          p: 3,
        }}
      >
        <AuthPageRightSection />
      </Box>
    </Box>
  );
};

export default CommonAuthLayout;
